module.exports = __webpack_public_path__ + "static/hero-recruitment-b8eebc48e0f5d292793b535b3db5e292.svg";